'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]).isRequired,
  headers: _propTypes.array,
  target: _propTypes.string,
  separator: _propTypes.string,
  filename: _propTypes.string
};

var defaultProps = exports.defaultProps = {
  separator: ',',
  filename: 'generatedBy_react-csv.csv'
};

var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-csv/lib/metaProps.js
 ** module id = 466
 ** module chunks = 0
 **/